import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { isEmpty, uniqBy, uniqueId } from 'lodash';
import { clusterList } from '@/services/resourceService';
import { getClusterVars } from '@/services/execVariableService';
import { isVoid } from '@/utils/common';

const initialState = {
  clusterOptions: [],
  variables: [], // 变量列表
  groups: [], // 变量组
  currentGroup: null, // 当前选中的组
  loading: false,
};

// 获取集群列表
export const fetchClusterOptions = createAsyncThunk(
  'execVariable/fetchClusterOptions',
  async (envId) => {
    const response = await clusterList({ envId, pageSize: 99999, startIndex: 1 });
    return response.data;
  },
);

// 获取集群变量
export const fetchClusterVars = createAsyncThunk(
  'execVariable/fetchClusterVars',
  async (params) => {
    const response = await getClusterVars(params);
    return response.data || [];
  },
);

export const execVariableSlice = createSlice({
  name: 'execVariable',
  initialState,
  reducers: {
    reset: () => {
      return initialState;
    },
    setCurrentGroup: (state, action) => {
      state.currentGroup = action.payload;
    },
    setCluster: (state, action) => {
      const { clusterOptions } = state;
      const clusterId = action.payload;
      state.cluster = clusterOptions.find((item) => item.value === clusterId);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchClusterOptions.pending, (state) => {
        state.clusterOptions = [];
      })
      .addCase(fetchClusterOptions.fulfilled, (state, action) => {
        const { items } = action.payload;
        return {
          ...initialState, // 清除其他
          clusterOptions: items.map((item) => ({
            ...item,
            value: item.id,
            label: item.name,
          })),
        };
      })
      .addCase(fetchClusterVars.pending, (state) => {
        state.loading = true;
        state.variables = [];
      })
      .addCase(fetchClusterVars.fulfilled, (state, action) => {
        const variables = action.payload.filter((item) => !isVoid(item.id));
        const groups = uniqBy(variables, 'groupId');
        state.variables = variables.map((item) => ({
          ...item,
          _key: uniqueId(),
        }));
        state.groups = groups;
        state.currentGroup = isEmpty(groups) ? null : groups[0]; // 默认第一个作为当前选中的组
        state.loading = false;
      })
      .addCase(fetchClusterVars.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setCluster, reset, setCurrentGroup } = execVariableSlice.actions;

export default execVariableSlice.reducer;
